module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-container"><div class="dialog-mask"></div><div class="dialog-wrap"><span class="close">✕</span><div class="dialog-body"> ' +
((__t = (body)) == null ? '' : __t) +
' </div></div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./components/dialog/index.html
// module id = 22
// module chunks = 0